import { OverThreeWithInfoAggEstesaItem } from '.';
import { ScommesseGridMultiple } from '../wrappers/scommesseGridMultiple';
import { ScommesseTipoProps } from '../types';
import { memo } from 'react';
import styles from './ScommesseTipoEsitiOverThreeWithInfoAggEstesa.module.scss';
import { useInfoAggiuntivaIndex } from 'features/sport/hooks';

export const Scommessa = memo(function Scommessa({ scommessaKey, gtagAction }: ScommesseTipoProps) {
  const infoAggIndex = useInfoAggiuntivaIndex(scommessaKey);
  const { nextInfoAgg } = infoAggIndex ?? {};

  return (
    <ScommesseGridMultiple noPaddingTop className={styles.gridContainer}>
      {nextInfoAgg?.map((infoAggiuntivaKey, index) => (
        <OverThreeWithInfoAggEstesaItem
          key={infoAggiuntivaKey}
          index={index}
          scommessaKey={scommessaKey}
          infoAggiuntivaKey={infoAggiuntivaKey}
          gtagAction={gtagAction}
        />
      ))}
    </ScommesseGridMultiple>
  );
});
